import { FieldOption } from '@components/form/v2';

import { resolveFieldOptions } from '../condition-helpers';
import { useFormBuilderContext } from '../context';
import { FieldContainingOptions } from '../state';

export const useFieldOptions = (field: FieldContainingOptions): FieldOption[] => {
  const { predefinedOptionsLists, marketplaceIntegrationLists = [] } = useFormBuilderContext();

  return resolveFieldOptions(field, predefinedOptionsLists, marketplaceIntegrationLists).options;
};
